import EmbedStoryPage from './EmbedStoryPage'
export default EmbedStoryPage;